import cn from 'classnames';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import ImageViewer from 'react-simple-image-viewer';
import { Column, Row } from '../../../../components/Basic/Blocks';
import { CheckButton } from '../../../../components/Basic/Buttons';
import { Input } from '../../../../components/Basic/Inputs';
import { HeaderTitle, Table, TableCell, TableHeader, TableLine } from '../../../../components/Basic/Table';
import { H2, Text, TextGrey } from '../../../../components/Basic/WrapsStyle';
import ProviderList from '../../../../components/Common/Input/ProviderList';
import { YANDEX_1, YANDEX_3, YANDEX_8 } from '../../../../constans';
import { WIDTH_OZON_ORDERS } from '../../Ozon';
import styles from './styles.module.scss';

const width = ['120px', '400px', '170px', '100px', '200px', '180px', '120px', '80px'];

const MARKET_ID = {
  [YANDEX_1]: '21623713',
  [YANDEX_3]: '22071066',
  'YANDEX-4': '22887912',
  'YANDEX-5': '22908529',
  'YANDEX-6': '53120673',
  'YANDEX-7': '53122012',
  [YANDEX_8]: '53116941',
};

const ORDER_LINK = (shop) => `https://partner.market.yandex.ru/supplier/${MARKET_ID[shop]}/orders/`;
const DOWNLOAD_LINK = (shop) =>
  `https://partner.market.yandex.ru/api/supplier/${MARKET_ID[shop]}/order/parcelBoxLabel/`;

export const formOrderLink = (id, shop) => `${ORDER_LINK(shop)}${id}`;
export const formStickerLink = (id, shop) => `${DOWNLOAD_LINK(shop)}${id}/${id}-1.pdf`;

const YandexTableSizes = ({ shop = '', orders = [], map = {}, pager = {}, total = 0, onChange = (_) => _ }) => {
  const user = useSelector((store) => store.user);
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [images, setImages] = useState([]);

  const isOwner = user.role === 'owner' || user.role === 'admin';

  const openImageViewer = (imgs) => {
    setImages(imgs);
    setIsViewerOpen(true);
  };

  const closeImageViewer = () => {
    setIsViewerOpen(false);
    setImages([]);
  };

  return (
    <>
      <H2 style={{ marginBottom: '10px' }}>Всего заказов: {total}</H2>

      <Table styles={styles.table}>
        <TableHeader whiteHeader={true} styles={styles.table_line}>
          <HeaderTitle width={width[3]} centerText>Площадка</HeaderTitle>
          <HeaderTitle width={width[0]}>Номер заказа</HeaderTitle>
          <HeaderTitle width={width[1]}>Позиции в заказе</HeaderTitle>
          <HeaderTitle width={width[5]} centerText>
            Артикул товара
          </HeaderTitle>
          <HeaderTitle width={width[7]} centerText>
            Ширина, мм
          </HeaderTitle>
          <HeaderTitle width={width[7]} centerText>
            Высота, мм
          </HeaderTitle>
          <HeaderTitle width={width[7]} centerText>
            Длина, мм
          </HeaderTitle>
          <HeaderTitle width={width[7]} centerText>
            Вес, кг
          </HeaderTitle>
          <HeaderTitle width={width[7]} centerText>
            Объемный вес
          </HeaderTitle>
          <HeaderTitle width={width[7]} centerText>
            Вес за квант
          </HeaderTitle>
          <HeaderTitle width={width[7]} centerText />
          <HeaderTitle width={width[6]} centerText>
            Стоимость доставки
          </HeaderTitle>
          <HeaderTitle width={width[6]} centerText>
            Квант продаж
          </HeaderTitle>
          <HeaderTitle width={width[6]} centerText>
            Количество в заказе
          </HeaderTitle>
          <HeaderTitle width={width[5]} centerText>
            Поставщик
          </HeaderTitle>
          <HeaderTitle width={width[6]} centerText>
            Артикул поставщика
          </HeaderTitle>
          <HeaderTitle width={width[6]} centerText>
            Артикул на складе
          </HeaderTitle>
        </TableHeader>
        {orders.map((order, key) => {
          const mapByShop = map[order.shop]
          return (
            <TableLine key={order.id}>
              <TableCell width={width[3]}>
                <Column style={{ alignItems: 'center' }}>
                  {order.shop}
                </Column>
              </TableCell>
              <TableCell width={width[0]} minWidth={width[0]}>
                <a href={formOrderLink(order.id, shop)} target="_blank" className={styles.link} rel="noopener noreferrer">
                  {order.id}
                </a>
                <TextGrey fontSize={14}>{order.creationDate}</TextGrey>
              </TableCell>
              <TableCell width={width[1]}>
                <Column>
                  {order.items.map((p, k) => {
                    const item = mapByShop[p.offerId] || {};
                    let loaded = !!mapByShop[p.offerId];
                    const img = loaded ? item.images || [] : []; // eslint-disable-next-line react/no-array-index-key
                    return (
                      <div key={k} className={styles.div_line_images}>
                        <div className={styles.wrapper}>
                          <img
                            onClick={() => openImageViewer(img)}
                            className={styles.preview}
                            src={img.length > 0 ? img[0] : undefined}
                          />
                        </div>
                        <div className={styles.name}>
                          {`${p.count} x ${p.offerName}`} <TextGrey fontSize={12}>{p.offerId}</TextGrey>
                          {(mapByShop[p.offerId] || { stocks_warehouse: 0 }).stocks_warehouse > 0 && (
                            <div
                              className={cn(
                                styles.warehouse_block,
                                (mapByShop[p.offerId] || { stocks_warehouse: 0 }).stocks_warehouse ===
                                (mapByShop[p.offerId] || {}).stocks && styles.only_warehouse,
                              )}
                            >
                              Склад
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </Column>
              </TableCell>
              <TableCell width={width[5]}>
                <Column style={{ alignItems: 'center' }}>
                  {order.items.map((p, k) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <div key={k} className={styles.div_line}>
                      {p.offerId}
                    </div>
                  ))}
                </Column>
              </TableCell>

              <TableCell width={width[7]}>
                <Column>
                  {order.items.map((p, k) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <Row
                      key={k}
                      className={cn(
                        styles.div_line,
                        mapByShop[p.offerId]?.status_flags?.is_check_size && styles.div_line_green,
                      )}
                    >
                      <Input
                        value={((mapByShop[p.offerId] || { sizes_package: {} }).sizes_package || {}).width}
                        onBlur={(v) => onChange(p.offerId, order.shop, 'width', v)}
                        center
                      />
                    </Row>
                  ))}
                </Column>
              </TableCell>
              <TableCell width={width[7]}>
                <Column>
                  {order.items.map((p, k) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <Row
                      key={k}
                      className={cn(
                        styles.div_line,
                        mapByShop[p.offerId]?.status_flags?.is_check_size && styles.div_line_green,
                      )}
                    >
                      <Input
                        value={((mapByShop[p.offerId] || { sizes_package: {} }).sizes_package || {}).height}
                        onBlur={(v) => onChange(p.offerId, order.shop, 'height', v)}
                        center
                      />
                    </Row>
                  ))}
                </Column>
              </TableCell>
              <TableCell width={width[7]}>
                <Column style={{ alignItems: 'center' }}>
                  {order.items.map((p, k) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <Row
                      key={k}
                      className={cn(
                        styles.div_line,
                        mapByShop[p.offerId]?.status_flags?.is_check_size && styles.div_line_green,
                      )}
                    >
                      <Input
                        value={((mapByShop[p.offerId] || { sizes_package: {} }).sizes_package || {}).depth}
                        onBlur={(v) => onChange(p.offerId, order.shop, 'depth', v)}
                        center
                      />
                    </Row>
                  ))}
                </Column>
              </TableCell>
              <TableCell width={WIDTH_OZON_ORDERS[7]}>
                <Column>
                  {order.items.map((p, k) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <Row
                      key={k}
                      className={cn(
                        styles.div_line,
                        mapByShop[p.offerId]?.status_flags?.is_check_size && styles.div_line_green,
                      )}
                    >
                      <Input
                        value={((mapByShop[p.offerId] || { sizes_package: {} }).sizes_package || {}).weight}
                        onBlur={(v) => onChange(p.offerId, order.shop, 'weight', v)}
                        center
                      />
                    </Row>
                  ))}
                </Column>
              </TableCell>
              <TableCell width={WIDTH_OZON_ORDERS[7]}>
                <Column>
                  {order.items.map((p, k) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <Row
                      key={k}
                      className={cn(
                        styles.div_line,
                      )}
                    >
                      <Input value={mapByShop[p.offerId].volume_weight} readOnly center />
                    </Row>
                  ))}
                </Column>
              </TableCell>
              <TableCell width={WIDTH_OZON_ORDERS[7]}>
                <Column>
                  {order.items.map((p, k) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <Row
                      key={k}
                      className={cn(
                        styles.div_line,
                      )}
                    >
                      <Input
                        value={(
                          (mapByShop[p.offerId] || { sizes_package: {} }).sizes_package.weight *
                          (mapByShop[p.offerId] || {}).min_quantity
                        ).toFixed(2)}
                        readOnly
                        center
                      />
                    </Row>
                  ))}
                </Column>
              </TableCell>
              <TableCell width={WIDTH_OZON_ORDERS[7]} center>
                <Column style={{ alignItems: 'center' }}>
                  {order.items.map((p, k) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <div key={k} className={styles.div_line}>
                      <CheckButton
                        disabled={!mapByShop[p.offerId]}
                        checked={mapByShop[p.offerId]?.status_flags?.is_check_size}
                        onSelect={() => {
                          console.log(p.offerId, 'is_check_size', !mapByShop[p.offerId]?.status_flags?.is_check_size);
                          onChange(p.offerId, order.shop, 'is_check_size', !mapByShop[p.offerId]?.status_flags?.is_check_size);
                        }}
                      />
                    </div>
                  ))}
                </Column>
              </TableCell>
              <TableCell width={width[6]}>
                <Column style={{ alignItems: 'center' }}>
                  {order.items.map((p, k) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <div key={k} className={styles.div_line}>
                      <Text fontWeight={600}>{(mapByShop[p.offerId] || {}).commission?.delivery_sort_center?.rub} ₽</Text>
                    </div>
                  ))}
                </Column>
              </TableCell>
              <TableCell width={width[6]}>
                <Column>
                  {order.items.map((p, k) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <div key={k} className={styles.div_line}>
                      <Input
                        value={(mapByShop[p.offerId] || {}).min_quantity}
                        onBlur={(v) => onChange((mapByShop[p.offerId] || {}).offer_id, order.shop, 'min_quantity', v)}
                        center
                      />
                    </div>
                  ))}
                </Column>
              </TableCell>

              <TableCell width={width[6]}>
                <Column>
                  {order.items.map((p, k) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <div key={k} className={styles.div_line}>
                      <Input
                        value={(mapByShop[p.offerId] || {}).quantity}
                        onBlur={(v) => onChange((mapByShop[p.offerId] || {}).offer_id, order.shop, 'quantity', v)}
                        center
                      />
                    </div>
                  ))}
                </Column>
              </TableCell>

              <TableCell width={width[5]}>
                <Column style={{ alignItems: 'center' }}>
                  {order.items.map((p, k) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <div key={k} className={styles.div_line}>
                      <ProviderList
                        selectProviderId={(mapByShop[p.offerId] || {}).provider_id}
                        disabled={!isOwner}
                        onSelect={(v) => onChange((mapByShop[p.offerId] || {}).offer_id, order.shop, 'provider_id', v.id)}
                      />
                    </div>
                  ))}
                </Column>
              </TableCell>
              <TableCell width={width[6]}>
                <Column>
                  {order.items.map((p, k) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <div key={k} className={styles.div_line}>
                      <Input
                        value={(mapByShop[p.offerId] || {}).provider_artnumber}
                        onBlur={(v) => onChange((mapByShop[p.offerId] || {}).offer_id, order.shop, 'provider_artnumber', v)}
                        center
                      />
                    </div>
                  ))}
                </Column>
              </TableCell>
              <TableCell width={width[6]}>
                <Column>
                  {order.items.map((p, k) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <div key={k} className={styles.div_line}>
                      <Input
                        value={(mapByShop[p.offerId] || {}).warehouse_id}
                        onBlur={(v) => onChange((mapByShop[p.offerId] || {}).offer_id, order.shop, 'warehouse_id', v)}
                        center
                      />
                    </div>
                  ))}
                </Column>
              </TableCell>
            </TableLine>
          )
        }
        )}
      </Table>
      {isViewerOpen && <ImageViewer src={images} currentIndex={0} onClose={closeImageViewer} />}
    </>
  );
};

export default YandexTableSizes;
